<template>
    <div class="discover-infinite">
        <div ref="hit" class="discover-infinite-hit"></div>
        <div v-if="loading" class="discover-infinite-tip">加载中…</div>
        <div v-else-if="done" class="discover-infinite-tip">没有更多了</div>
    </div>
</template>

<script>
    export default {
        name: 'InfiniteFooter',
        props: {
            loading: {
                type: Boolean,
                default: false
            },
            done: {
                type: Boolean,
                default: false
            }
        },
        data: function () {
            return {
                armed: true
            };
        },
        mounted: function () {
            this.bindObserver();
        },
        beforeDestroy: function () {
            this.unbindObserver();
        },
        watch: {
            loading: function (now, prev) {
                if (prev && !now) {
                    if (!this._visible) {
                        this.armed = true;
                    }
                }
            },
            done: function (val) {
                if (!val) {
                    this.armed = true;
                }
            }
        },
        methods: {
            tryLoad: function () {
                if (this.loading || this.done || !this.armed) return;
                this.armed = false;
                this.$emit('load');
            },
            bindObserver: function () {
                if (typeof IntersectionObserver === 'undefined') {
                    this.bindScrollFallback();
                    return;
                }
                const hit = this.$refs.hit;
                if (!hit) return;
                const root = this.findScrollRoot(hit);
                if (this._ioRoot === root && this._io) return;
                this.unbindObserver();
                const self = this;
                this._ioRoot = root;
                this._io = new IntersectionObserver(function (entries) {
                    const visible = entries.some(function (entry) { return entry.isIntersecting; });
                    self._visible = visible;
                    if (!visible) {
                        self.armed = true;
                        return;
                    }
                    self.tryLoad();
                }, {
                    root: root,
                    rootMargin: '80px',
                    threshold: 0
                });
                this._io.observe(hit);
            },
            bindScrollFallback: function () {
                if (this._onScroll) return;
                const hit = this.$refs.hit;
                const root = this.findScrollRoot(hit);
                if (!root) return;
                const self = this;
                this._scrollRoot = root;
                this._onScroll = function () {
                    const remain = root.scrollHeight - root.scrollTop - root.clientHeight;
                    self._visible = remain < 80;
                    if (!self._visible) {
                        self.armed = true;
                        return;
                    }
                    self.tryLoad();
                };
                root.addEventListener('scroll', this._onScroll, { passive: true });
            },
            findScrollRoot: function (el) {
                let node = el && el.parentElement;
                while (node && node !== document.body) {
                    if (node.classList && (node.classList.contains('discover-list') || node.classList.contains('room-inline-list'))) {
                        return node;
                    }
                    const style = window.getComputedStyle(node);
                    const oy = style.overflowY;
                    if ((oy === 'auto' || oy === 'scroll' || oy === 'overlay') && node.scrollHeight > node.clientHeight + 4) {
                        return node;
                    }
                    node = node.parentElement;
                }
                return null;
            },
            unbindObserver: function () {
                if (this._io) {
                    this._io.disconnect();
                    this._io = null;
                    this._ioRoot = null;
                }
                if (this._onScroll && this._scrollRoot) {
                    this._scrollRoot.removeEventListener('scroll', this._onScroll);
                    this._onScroll = null;
                    this._scrollRoot = null;
                }
            }
        }
    }
</script>
